"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MultiplicityType;
(function (MultiplicityType) {
    MultiplicityType[MultiplicityType["Single"] = 1] = "Single";
    MultiplicityType[MultiplicityType["Multiple"] = 2] = "Multiple";
})(MultiplicityType = exports.MultiplicityType || (exports.MultiplicityType = {}));
//# sourceMappingURL=MultiplicityType.js.map